<template>
  <v-container class="text-center">
    <div class="eighteen">
      <span>18+</span>
    </div>
    <h2>You must be 18+ to view this website</h2>
    <p>You must be at least eighteen years old to view this content. Are you over eighteen and willing to see adult content?</p>
    <div class="v-flex">
      <v-btn class="mr-2" href="https://google.com">No thank you</v-btn>
      <v-btn color="primary" @click="redirect">Continue</v-btn>
    </div>
  </v-container>
</template>

<script>
import Cookies from 'js-cookie'

export default {
  methods: {
    redirect () {
      Cookies.set('is18', true, { expires: 14, path: '' })
      this.$router.replace(this.$route.params.nextUrl || { name: 'Home' })
    }
  }
}
</script>

<style scoped>
.eighteen {
  display: inline-block;
  height: 150px;
  width: 150px;
  background: #ec1b30;
  border-radius: 50%;
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.eighteen > span {
  font-size: 65px;
  line-height: 150px;
}
</style>
